import { NgModule } from "@angular/core";

import { FilterPipe } from "@core/pipes/filter.pipe";

import { InitialsPipe } from "@core/pipes/initials.pipe";

import { SafePipe } from "@core/pipes/safe.pipe";
import { StripHtmlPipe } from "@core/pipes/stripHtml.pipe";
import { PipeModule } from "../../app/util/pipe/pipe.module";

@NgModule({
  declarations: [InitialsPipe, FilterPipe, StripHtmlPipe, SafePipe],
  imports: [PipeModule],
  exports: [InitialsPipe, FilterPipe, StripHtmlPipe, SafePipe, PipeModule],
})
export class CorePipesModule {}
